const fresh = (rule) => new Map(rule.kinds.map((k) => [k.key, k.perTurn]));
/** Take one of `kind` from the budget, by its own count or a trade; false (nothing taken) when it would go over. */
function take(rule, budget, kind) {
    if (!budget.has(kind))
        return false;
    const own = budget.get(kind);
    if (own === null)
        return true;
    if (own > 0) {
        budget.set(kind, own - 1);
        return true;
    }
    for (const t of rule.trades) {
        if (t.get !== kind)
            continue;
        const need = new Map();
        for (const g of t.give)
            need.set(g, (need.get(g) ?? 0) + 1);
        if (![...need].every(([g, n]) => { const have = budget.get(g); return have === null || (have !== undefined && have >= n); }))
            continue;
        for (const [g, n] of need) {
            const have = budget.get(g);
            if (have !== null)
                budget.set(g, have - n);
        }
        return true;
    }
    return false;
}
/** The actions taken, in order, each marked over or not by the rule. */
export function countActions(rule, kinds) {
    const budget = fresh(rule);
    return kinds.map((kind) => ({ kind, over: !take(rule, budget, kind) }));
}
/** One more action taken, or (`spend` false) the last one of that kind taken back: the turn's list counted again. */
export function spendAction(rule, spent, kind, spend) {
    const kinds = spent.map((s) => s.kind);
    if (spend)
        kinds.push(kind);
    else {
        const i = kinds.lastIndexOf(kind);
        if (i >= 0)
            kinds.splice(i, 1);
    }
    return countActions(rule, kinds);
}
/** How many more of a kind fit after what was taken, by the same count; past twenty is as many as the data allows. */
function leftOf(rule, spent, kind) {
    const per = rule.kinds.find((k) => k.key === kind)?.perTurn;
    if (per === null)
        return null;
    const budget = fresh(rule);
    for (const s of spent)
        if (!s.over)
            take(rule, budget, s.kind);
    let n = 0;
    while (n < 20 && take(rule, budget, kind))
        n += 1;
    return n;
}
/** The row: every kind of the system, in its order, with what this turn used of it and what is left. */
export function tallyActions(rule, spent) {
    return rule.kinds.map((k) => ({
        key: k.key, label: k.label,
        used: spent.filter((s) => s.kind === k.key).length,
        left: leftOf(rule, spent, k.key),
        over: spent.filter((s) => s.kind === k.key && s.over).length,
    }));
}
//# sourceMappingURL=actions.js.map